import MobileHeaderWrapper from './MobileHeaderWrapper'

export default MobileHeaderWrapper
